import React from 'react'
import './modal-download.scss'
import { StaticImage } from 'gatsby-plugin-image'
import corazonCreciente from '../../../assets/images/contenidos-descargables/corazon-creciente.png'

const TextThanks = (text: string) => (
  <div className='f-modal-download-text'>
    <p>
    <img src={corazonCreciente} alt="heart" />
      <b>¡Listo!</b> Ya se está <br /> <b>descargando {text}</b>
    </p>
  </div>
)

const ModalDownload = ({card}: any) => {
  return (
    <div className="f-modal-download">
      <div className='image-wrapper'>
        <StaticImage
          src='../../../assets/images/thanks.webp'
          alt="thanks"
          className="heart-image"
          placeholder="blurred"
          width={200}
        />
      </div>
      {TextThanks(card.textDownload)}
    </div>
  )
}

export default ModalDownload
